export const LOGIN = "login";
export const LOGIN_STATS = "login-stats";
export const VERIFYEMAIL = "verifyEmail";
export const FORGOTPASSWORD = "verifyOtpAndUpdate" + "Password";
export const CHANGEPASSWORD = "reset" + "Password";

//common
export const LISTOFCENTER = "center/centerList";
export const FILEUPLOAD = "common/fileUploads";
export const FILEDELETE = "deleteUploadedFile";
export const LISTOFSTATE = "common/listOfState";
export const LISTOFDISTRICT = "common/listOfDistrict";
export const LISTOFCITY = "common/listOfCity";
export const LISTOFROLE = "/role/listOfRole";
export const FILEDOWNLOAD = "downloadFile";
export const SUBSCRIPTIONLIST = "/staff/lastOfSubscription";

//Master-Center
export const ADDCENTER = "center/addCenter";
export const EDITCENTER = "center/editCenter/";
export const CENTERLIST = "center/listOfCenter";
export const DELETECENTER = "center/deleteCenter/";
export const LISTOFSCHEME = "center/listOfScheme";

//Position
export const LISTOFPOSITION = "common/listOfPosition";
export const ADDPOSITION = "position/addPosition";
export const EDITPOSITION = "position/editPosition";
export const DELETEPOSITION = "position/deletePosition";

//HolidayTemplate
export const ADDHOLIDAY = "stock-type/addStockType";
export const EDITHOLIDAY = "stock-type/editStockType/";
export const LISTOFHOLIDAY = "holiday/listOfHolidayTemplate";
export const LISTOFHOLIDAYDROP = "holiday/listOfHolidayTemplateName";
export const DELETETEMPLATE = "holiday/DeleteTemplate/";

//HR-Staff
export const LISTOFSTAFFHR = "staff/listOfStaff";
export const ADDSTAFFHR = "staff/addStaff";
export const EDITSTAFFHR = "staff/editStaff/";
export const VIEWSTAFFHR = "staff/viewStaff/";
export const DELETESTAFFHR = "staff/deleteStaff/";
export const VIEWSTAFFIDS = "staff/staffIds";
export const LISTOFROLEFORSTAFF = "staff/listOfRoleForStaff";
export const STAFFIMAGE = "/staff/viewStaffImage/";
export const VIEWPROFILE = "staff/viewProfile";
export const STAFFACCESS = "updateAppAccess";
export const ACTIVEINACTIVESTAFF = "staff/activeInActiveStaff/";
export const RESET_EMAIL = "staff/resetEmail/";

//HR-Attendance
export const ADDATTENDACNE = "staff-attendance/addStaffAttendance/";
export const ADDNOTE = "staff-attendance/addStaffAttendanceNote/";
export const VIEWLOGS = "staff-attendance/viewStaffAttendanceHistory/";
export const VIEWATTENDANCE = "staff-attendance/listOfStaffAttendance";
export const LISTOFWORKINGDAY = "staff-attendance/listOfCompOffLeave";
export const REVERTTOHOLIDAY = "staff-attendance/revertHoliday/";
export const REVERTWEEKOFF = "staff-attendance/revertWeekOff/";
export const LEAVEHISTORY = "staff-attendance/leaveHistory/";

//HR-Holiday Template
export const LISTOFHOLIDAYTEMPLATE = "holiday/listOfHolidayTemplate";
export const ADDHOLIDAYTEMPLATE = "holiday/template";
export const EDITHOLIDAYTEMPLATE = "holiday/template/";
export const VIEWHOLIDAYTEMPLATE = "holiday/template/";
export const DELETEHOLIDAYTEMPLATE = "holiday/template/";
export const DELETEHOLIDAY = "holiday/deleteHolidayDetails/";
export const MANAGESTAFFLIST = "holiday/manageStaffList/";
export const EDITMANAGESTAFF = "holiday/editManageStaffList/";

// ATTENDENCE_MODE-SETTING
export const ATTENDENCEMODE = "global-settings/attendance-mode";
export const MONTHDURATION = "global-settings/updateSalaryCalculationMethod";
export const SALARYCALCULATION = "global-settings/getSalaryCalculationMethod";
export const ATTENDANCEDATA = "global-settings/getGlobalAttendance";

// SalaryDetails
export const SALARYDETAILS = "global-settings/listOfSalaryAccess";
export const UPDATESALARYACCESS = "global-settings/updateSalaryAccess";
export const SALARYACCESS = "global-settings/salaryAccess";

//Leave Template
export const LISTOFLEAVETEMPLATEDROP = "leave/listOfLeaveTemplateName";

//Reporting Manager
export const LISTOFREPORTINGDROP = "staff/listOfReportingTo";
export const LISTOFSHIFTDROP = "shift/listOfShiftName";

//master role
export const ADDROLE = "role/addRole";
export const EDITROLE = "role/editRole/";
export const LISTROLE = "role/listOfRole";
export const DELETEROLE = "role/deleteRole/";

//HR-Leave Template
export const LISTOFLEAVETEMPLATE = "leave/listOfLeaveTemplate";
export const ADDLEAVETEMPLATE = "leave/addLeave";
export const VIEWLEAVETEMPLATE = "leave/viewLeaveTemplate/";
export const EDITLEAVETEMPLATE = "leave/editLeaveTemplate/";
export const DELETELEAVETEMPLATE = "leave/deleteLeaveTemplate/";
export const LISTOFLEAVECATEGORIES = "leave/listOfLeaveCategory";
export const DELETELEAVECATEGORIES = "leave/deleteLeaveCategory/";
export const VIEWLEAVESTAFF = "leave/leaveStaffList/";
export const EDITLEAVESTAFF = "leave/editLeaveStaffList/";

//HR-Shift Setting
export const LISTOFSHIFT = "shift/listOfShift";
export const EDITSHIFTSTAFFLIST = "shift/editShiftStaffList/";
export const SHIFTSTAFFLIST = "shift/shiftStaffList/";
export const EDITSHIFT = "shift/editShift/";
export const VIEWSHIFT = "shift/viewShift/";
export const ADDSHIFT = "shift/addShift";
export const DELETESHIFT = "shift/deleteShift/";

//HR-Dashborad
export const ATTENDACNEMUSTERROLL = "staff-attendance/attendanceMusterRollReport";
export const COUNTOFSTAFFATTENDANCESTATUS = "staff-attendance/countOfDayWiseStaffAttendanceStatus";

//Role
export const LISTOFMASTERMODULE = "role-permission/listOfMasterModule";
export const ADDROLEPERMISSION = "role-permission/addRole";
export const VIEWROLEPERMISSION = "role-permission/viewRole/";
export const EDITROLEPERMISSION = "role-permission/editRole/";
export const DELETEROLEPERMISSION = "role-permission/deleteRole/";
export const LISTOFROLEPERMISSION = "role-permission/listOfRole";
export const LISTOFUSERROLEPERMISSION = "role-permission/userRolePermission";

//HR-Salary
export const EFFECTIVECYCLE = "salary/staffWiseEffectiveCycle/";
export const VIEWSALARYSTRUCTURE = "salary/viewSalaryStructure/";
export const EDITSALARYSTRUCTURE = "salary/editSalaryStructure/";
export const REVISESALARY = "salary/reviseSalaryStructure/";
export const REVISIONHISTORY = "salary/listOfReviseSalary/";
export const LISTOFSALARYOVERVIEW = "salary/listOfSalaryOverview/";
export const VIEWSALARYOVERVIEW = "salary/viewSalaryOverview/";

//ATTENDENCE_DETAIL
export const ATTENDENCEMUSTERROLL = "staff-attendance/attendanceMusterRollReport";

//Report
export const HALFSALARYSLIP = "salary/GenerateHalfSalarySlip";
export const FULLSALARYSLIP = "salary/GenerateFullSalarySlip";
export const EXITEMPLOYEE = "report/exitStaffDetail";
export const MUSTERROLL = "report/staffAttendanceMusterRoll";
export const DAILYATTENDANCE = "report/dailyAttendanceReport";
export const ATTENDANCEPAYROLL = "report/payrollAttendanceReviewReport";
export const ACCOUNTDETAIL = "report/staffAccountDetails";
export const STAFFDETAIL = "report/staffDetails";
export const LEAVEBALANCE = "report/leaveBalanceReport";
export const LEAVESUMMARY = "report/leaveSummary";
export const STAFFATTENDANCE = "staff-attendance/staffAttendanceExport";
export const JOINING_LETTER = "report/joiningLetter/";
export const EXPERIENCE_LETTER = "report/experienceLetter/";

//ApprovalApi
export const ATTENDANCEAPPROVALLIST = "staff-attendance/listOfAttendanceApprove";
export const EDITATTENDANCEAPPROVAL = "staff-attendance/editAttendanceApprove";
export const LEAVEAPPROVALLIST = "leave-app/listOfAllLeave";
export const LEAVEAPPROVALSUMMARYLIST = "leave-app/listOfAllLeaveSummary";
export const EDITLEAVEAPPROVAL = "leave-app/editLeaveStatus";

//LeaveSummary
export const LEAVESUMMARYLIST = "staff/monthWiseLeaveCountOfStaff/";
export const PERDAYSALARY = "staff/viewStaffPerDaySaalry/";
export const ENCASHLEAVE = "staff/staffEncashLeaves/";
export const VIEWENCASHLEAVEHISTORY = "staff/viewEncashLeaveHistory/";

//LeaveBalance
export const STAFFLEAVEBALANCE = "staff/viewStaffLeaves/";
export const EDITLEAVEBALANCE = "staff/addStaffLeave/";
export const LEAVE_BALANCE_HISTORY = "staff/listOfLeaveBalanceHistory";

//extra-working-day
export const ADD_EXTRA_WORKING_DAY = "extra-working-day/addExtraWorkingDay";
export const EDIT_EXTRA_WORKING_DAY = "extra-working-day/editExtraWorkingDayDetail";
export const EXTRA_WORKING_DAY_LIST = "extra-working-day/listOfExtraWorkingDays";
export const VIEW_EXTRA_WORKING_DAY = "extra-working-day/viewExtraWorkingDay/";
export const DELETE_EXTRA_WORKING_DAY = "extra-working-day/deleteExtraWorkingDay/";

//Organization
export const ADDORGANIZATION = "organizations/addOrganization";
export const EDITORGANIZATION = "organizations/editOrganization/";
export const VIEWOFRGANIZATION = "organizations/";
export const ONBOARDING_STATUS = "organizations/";
export const LISTOFORGANIZATION = "organizations/listOfOrganization";
export const DELETEORGANIZATION = "organizations/deleteOrganization/";

//Sales-Lead
export const CREATE_LEAD = "/lead/createLead";
export const UPDATE_LEAD = "/lead/updateLead";
export const LEAD_LIST = "/lead/listOfLeads";
export const VIEW_LEAD = "/lead/viewLead/";
export const UPDATE_LEAD_STATUS = "/lead/updateLeadStatus";
export const CONNECTED_PROFILE_LIST = "/lead/listOfConnectedProfile";
export const IMPORT_LEAD_DATA = "/lead/importLeadData";

//Sales-Company
export const COMPANY_LIST = "/company/listOfCompany";
export const COMPANY_LIST_PAGINATION = "/company/listOfCompanies";
export const CREATE_COMPANY = "/company/createCompany";
export const EDIT_COMPANY = "/company/editCompany";
export const DELETE_COMPANY = "company/deleteCompany/";
export const IMPORT_COMPANY_DATA = "/company/importCompanyData";

//Sales-Contact
export const CONTACT_LIST = "contact/listOfContact";
export const CONTACT_LIST_PAGINATION = "contact/listOfContacts";
export const CREATE_CONTACT = "contact/createContact";
export const EDIT_CONTACT = "contact/editContact";
export const DELETE_CONTACT = "contact/deleteContact/";
export const POSITION_LIST = "/contact/listOfSalesPosition";
export const IMPORT_CONTACT_DATA = "/contact/importContactData";

//BDE-Aliased
export const CREATE_ALIASED = "aliased/createTechnology";
export const ALIASED_LIST = "aliased/listOfTechnologies";
export const EDIT_ALIASED = "aliased/editTechnology";
export const DELETE_ALIASED = "aliased/deleteTechnology/";

//BDE-Technology
export const CREATE_TECHNOLOGY = "technology/createTechnology";
export const TECHNOLOGY_LIST = "technology/listOfTechnologies";
export const EDIT_TECHNOLOGY = "technology/editTechnology";
export const DELETE_TECHNOLOGY = "technology/deleteTechnology/";

//Sales-Deal
export const CREATE_DEAL = "/deal/createDeal";
export const UPDATE_DEAL = "/deal/editDeal";
export const DEAL_LIST = "/deal/listOfDeals";
export const VIEW_DEAL = "/deal/viewDeal/";
export const DELETE_DEAL = "/deal/deleteDeal/";
export const UPDATE_DEAL_STATUS = "/deal/updateDealStatus";

// Graph Data
export const STACKED_GRAPH = "interview/staffInterviewGraph";
export const TECHNOLOGY_GRAPH = "interview/technologyGraph";

//sales-inteview
export const CREATE_INTERVIEW = "/interview/createInterview";
export const DELETE_INTERVIEW = "/interview/deleteInterview/";
export const UPDATE_INTERVIEW = "/interview/editInterview";
export const INTERVIEW_LIST = "/interview/listOfInterview";
export const VIEW_INTERVIEW = "/interview/viewInterview/";
export const UPDATE_INTERVIEW_STATUS = "/interview/editInterviewStatus";
export const SCHEDULE_LIST = "/interview/listOfScheduler";
export const DEVELOPER_LITS = "/interview/listOfDevelopers";

// Inquiry
export const INQUIRY_LIST = "/contact-inquiry/listOfInquiries";
export const UPDATE_INQUIRY_STATUS = "/contact-inquiry/updateInquiryStatus";
export const GET_INQUIRY_BY_ID = "/contact-inquiry/getInquiryById";

// Banks
export const BANK_LIST = "banks/bankList";

// Payroll - Templates
export const PAYROLL_TEMPLATE_LIST = "payroll/listOfPayrollTemplate";
export const PAYROLL_TEMPLATE_CREATE = "payroll/addPayrollTemplate";
export const PAYROLL_TEMPLATE_VIEW = "payroll/viewPayrollTemplate/";
export const PAYROLL_TEMPLATE_EDIT = "payroll/editPayrollTemplate/";
export const PAYROLL_TEMPLATE_CLONE = "payroll/clonePayrollTemplate/";
export const PAYROLL_TEMPLATE_TOGGLE = "payroll/togglePayrollTemplate/";
export const PAYROLL_TEMPLATE_DELETE = "payroll/deletePayrollTemplate/";

// Payroll - Run
export const PAYROLL_RUN_INITIATE = "payroll/initiatePayrollRun";
export const PAYROLL_RUN_VIEW = "payroll/viewPayrollBatch/";
export const PAYROLL_RUN_APPROVE = "payroll/approvePayrollBatch/";
export const PAYROLL_RUN_MARK_PAID = "payroll/markPayrollBatchPaid/";
export const PAYROLL_BATCH_LIST = "payroll/listOfPayrollBatch";

// Payroll - Reports
export const PAYROLL_SALARY_REGISTER = "payroll/salaryRegisterReport";
export const PAYROLL_PF_REPORT = "payroll/pfReport";
export const PAYROLL_TDS_REPORT = "payroll/tdsReport";
export const PAYROLL_BANK_TRANSFER = "payroll/bankTransferList";

// Payroll - Settings
export const PT_SLAB_LIST = "payroll/listOfPtSlab";
export const PT_SLAB_SAVE = "payroll/savePtSlabs";
export const TDS_SLAB_LIST = "payroll/listOfTdsSlab";
export const TDS_SLAB_SAVE = "payroll/saveTdsSlabs";

// Overtime - Policy
export const OVERTIME_POLICY_CREATE = "overtime/policy";
export const OVERTIME_POLICY_UPDATE = "overtime/policy/";
export const OVERTIME_POLICY_LIST = "overtime/listOfOvertimePolicy";
export const OVERTIME_POLICY_GET_ALL = "overtime/policy";

// Overtime - Request
export const OVERTIME_REQUEST_CREATE = "overtime/request";
export const OVERTIME_REQUEST_PRE_APPROVAL = "overtime/request/pre-approval";
export const OVERTIME_REQUEST_APPROVE = "overtime/approve/";

// Overtime - Summary & Reports
export const OVERTIME_SUMMARY = "overtime/summary/";
export const OVERTIME_REPORT = "overtime/report";

// Overtime - Request & Approval Flow
export const OVERTIME_STAFF_SUMMARY_LIST = "overtime/listOfStaffOvertimeSummary";
export const OVERTIME_STAFF_REQUESTS_LIST = "overtime/listOfStaffOvertimeRequests";
export const OVERTIME_VIEW_REQUEST = "overtime/viewOvertimeRequest/";
export const OVERTIME_ADD_REQUEST = "overtime/addOvertimeRequest";

// Letter Templates & Settings
export const LETTER_CONFIG_ENDPOINT = "letter-settings/config";
// Support Center
export const SUPPORT_TICKET_LIST = "support/listOfTickets";
export const SUPPORT_TICKET_CREATE = "support/createTicket";
export const SUPPORT_TICKET_VIEW = "support/viewTicket/";
export const SUPPORT_TICKET_EDIT = "support/editTicket/";
export const SUPPORT_TICKET_DELETE = "support/deleteTicket/";
export const SUPPORT_TICKET_STATUS = "support/updateTicketStatus/";
